import React, {useState} from "react";
import {Text, Container, ActionIcon, Group, rem, Image, Box, useMantineTheme} from "@mantine/core";
import {
  IconBrandTwitter,
  IconBrandYoutube,
  IconBrandInstagram,
  IconBrandDiscord,
  IconBrandFacebook,
  IconBrandDiscordFilled,
  IconBrandFacebookFilled,
  IconBrandLinkedin,
} from "@tabler/icons-react";
import classes from "./Footer.module.scss";

interface FooterProps {
  sections: Array<{
    title: any;
    links: Array<{
      label: any;
      link?: string;
      onClick?: any;
    }>;
  }>;
}

export default function Footer({sections}: FooterProps) {
  const theme = useMantineTheme();

  const groups = sections.map((group) => {
    const links = group.links.map((link, index) => (
      <Text
        key={index}
        className={classes.link}
        onClick={link.onClick ? (event: any) => event.preventDefault() : undefined}
        renderRoot={link.link ? (props: any) => <a href={link.link} {...props} /> : undefined}>
        {link.label}
      </Text>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <Box className={classes.footer} bg={theme.colors.text[0]}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <Image src="/assets/logo/fig-full-white.png" w={rem(120)} />
          <Text size="xs" c="dimmed" className={classes.description}>
            Wealth management for freelancers
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text c="dimmed" size="sm">
          © {new Date().getFullYear()} Fig. All rights reserved.
        </Text>

        <Group gap={0} className={classes.social} justify="flex-end" wrap="nowrap">
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            renderRoot={(props) => <a href={"https://discord.gg/E9rHJfZ2eg"} {...props} />}>
            <IconBrandDiscordFilled style={{width: rem(18), height: rem(18)}} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            renderRoot={(props) => <a href={"https://www.facebook.com/profile.php?id=100095351472088"} {...props} />}>
            <IconBrandFacebookFilled style={{width: rem(18), height: rem(18)}} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            renderRoot={(props) => <a href={"https://www.instagram.com/figforfreelancers/"} {...props} />}>
            <IconBrandInstagram style={{width: rem(18), height: rem(18)}} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            renderRoot={(props) => <a href={"https://www.linkedin.com/company/figwealth"} {...props} />}>
            <IconBrandLinkedin style={{width: rem(18), height: rem(18)}} stroke={1.5} />
          </ActionIcon>
        </Group>
      </Container>
      {/* <Container className={classes.disclosure}>
        <Text c="dimmed" size="sm">
          Fig is a financial technology company, not a bank. The material on this page does not provide tax, legal,
          investment, or accounting advice. This is not an offer to buy or sell any security or to participate in any
          investment strategy. The strategies and/or investments discussed in this material may not be suitable for all
          investors. The appropriateness of a particular investment or strategy will depend on an investor’s individual
          circumstances and objectives.
        </Text>
      </Container> */}
    </Box>
  );
}
